import { coins } from '../mockedData'

export const getCoinsByNetwork = (network) => {
  let coinsFiltered = []

  switch (network) {
    case 'polygon':
      coinsFiltered = coins.filter((coin) => coin.value !== 'TRX')
      break
    case 'tron':
      coinsFiltered = coins.filter(
        (coin) => coin.value !== 'USDC' && coin.value !== 'POL'
      )
      break
    default:
      coinsFiltered = []
  }

  return coinsFiltered
}
